import { render, staticRenderFns } from "./FacetHierarchy.vue?vue&type=template&id=74457624&scoped=true&"
import script from "./FacetHierarchy.vue?vue&type=script&lang=js&"
export * from "./FacetHierarchy.vue?vue&type=script&lang=js&"
import style0 from "./FacetHierarchy.vue?vue&type=style&index=0&id=74457624&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74457624",
  null
  
)

export default component.exports